// extracted by mini-css-extract-plugin
export default {"-large":"potnl9d1o7qBsf2fQaT8","container":"SH6mnYkhF56vrlcqwF8J","divider":"hV7Dkgny4759eE1xRSUR"};